import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';

interface ClientStatusBadgeProps {
  isActive: boolean;
  size?: 'sm' | 'md';
}

export const ClientStatusBadge: React.FC<ClientStatusBadgeProps> = ({ 
  isActive,
  size = 'md'
}) => {
  const config = isActive
    ? {
        color: 'bg-green-200 text-green-900 border-green-300',
        dotColor: 'bg-green-700',
        label: 'Activo',
        icon: <CheckCircle className="w-3.5 h-3.5" />
      }
    : {
        color: 'bg-red-200 text-red-900 border-red-300',
        dotColor: 'bg-red-700',
        label: 'Inactivo',
        icon: <XCircle className="w-3.5 h-3.5" />
      };

  const textSize = size === 'sm' ? 'text-[10px]' : 'text-xs';

  return (
    <div 
      className={`${config.color} inline-flex items-center gap-2 w-fit border rounded-full px-3 py-1`}
    >
      <span className={`block h-1.5 w-1.5 rounded-full ${config.dotColor}`} />
      <span className={`${textSize} font-medium uppercase tracking-wide`}>
        {config.label}
      </span>
    </div>
  );
};
